// extracted by mini-css-extract-plugin
export default {"DividerHorizontal":"Divider_DividerHorizontal__YaZ4z","VerticalDivider":"Divider_VerticalDivider__I2vOJ","dark":"Divider_dark__bdCMj","light":"Divider_light__iC4ig"};